module.exports = __webpack_public_path__ + "static/media/iPhoneXBlackModal.b494ea5f.png";